import {SvgIconData} from '@shared-web/components/core/svg_icon';

export const chevronLeftIcon: SvgIconData = {
  viewBox: '8 6 7.5 12',
  element: <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />,
};
